module.exports = __webpack_public_path__ + "img/UA.65bbce38.svg";